import Layout from '../layout/index.vue'

export default [
	{
		path: '/bi',
		name: 'Bi',
		component: () => import('../views/bi/index.vue')
	},
];